import { render, staticRenderFns } from "./NewLead.vue?vue&type=template&id=96f81952"
import script from "./NewLead.vue?vue&type=script&lang=js"
export * from "./NewLead.vue?vue&type=script&lang=js"
import style0 from "./NewLead.vue?vue&type=style&index=0&id=96f81952&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports